import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {MagazineWriterService} from "../../serverService/magazineService/MagazineWriterService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoToggleOutlined
} from "@moeindal/base-raiko-panel-components";

const WriterAccessState = () => {

    const {id: writerId} = useParams()

    const service = new MagazineWriterService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [banState, setBanState] = useState(false);

    useEffect(() => {
        if (typeof writerId !== 'undefined' && writerId > 0) {
            getWriterAccess();
        }
    }, [writerId]);

    function getWriterAccess() {
        loading.show()
        service.getWriterAccess(writerId)
            .then(response => {
                setBanState(response.enabled)
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function changeManagerEnabledState(state) {
        loading.show()
        console.log("state is ", state)
        service.updateWriterAccess(writerId, state)
            .then(response => {
                if (state) {
                    snackbar.showSuccessMessage("دسترسی به سامانه برای نویسنده آزاد شد.")
                } else {
                    snackbar.showWarningMessage("دسترسی نویسنده با موفقیت مسدود شد.")
                }
                console.log("state is ", state)
                setBanState(state)
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    return (

        <RaikoBaseCardContainer className={css`margin-top: 1rem;`}>
            <RaikoSectionContainer title={"مسدود سازی"}>
                <RaikoGridOneColumn>
                    <Alert severity="error" className={css`width: 100%;`}>
                        <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
                        <div className={css`display: flex;
                          flex-direction: column;
                          gap: 8px;
                          margin-top: 16px;
                        `}>
                            <span>با مسدود سازی نویسنده دسترسی نویسنده به پنل مسدود خواهد شد.</span>
                        </div>
                    </Alert>
                    <RaikoToggleOutlined
                        labelText={"مسدود سازی"}
                        setChecked={state => {
                            changeManagerEnabledState(!state)
                        }}
                        checked={!banState}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>

    )
}

export default WriterAccessState